module.exports = __webpack_public_path__ + "static/media/attendance_code.834fbf44.png";